
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useLocale from 'next-translate/useTranslation';
import React from 'react';
import WhatsNew from '@/components/atoms/WhatsNew';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import Seo from '@/components/Seo';
const Changelog = () => {
    const { t } = useLocale('whats_new');
    return (<main className='dark:bg-slate-900'>
      <Seo templateTitle={t(`What's New`)} description={t('See all the latest updates and changes to the Easy-Peasy.AI.')} image={`https://easy-peasy.ai/api/og-template?title=${t("What's New")}&description=${t('See all the latest updates and changes to the Easy-Peasy.AI.')}`}/>
      <div className='dark:bg-slate-900 bg-white'>
        <div className='mx-auto'>
          <div className='relative z-10 dark:bg-slate-900 bg-white sm:pb-8  lg:w-full '>
            <LandingPageNavigation />
          </div>
        </div>
      </div>
      <section className='bg-gray-100 dark:bg-slate-900 py-16 px-4 sm:px-6 lg:px-8'>
        <div className='mx-auto max-w-4xl md:px-8 xl:px-0 mt-6 text-gray-500'>
          <WhatsNew isLandingPage={true}/>
        </div>
      </section>
      <Footer />
    </main>);
};
export default Changelog;
// add static props
async function getStaticProps() {
    return {
        props: {},
    };
}

    async function __Next_Translate__getStaticProps__1a0cbfb6690__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/changelog',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0cbfb6690__ as getStaticProps }
  